import React from 'react';

const PrivacyPolicy = () => {
  return (
    <div className="page-container privacy-theme">
      {/* Enhanced Page Header */}
      <div className="page-header">
        <h1 className="page-main-title">
          🔒 የጥበቃ መመሪያ
        </h1>
        <div className="page-subtitle">
          Privacy Policy - የግል መረጃ ጥበቃ መመሪያ
        </div>
        <div className="page-description">
          <p className="page-description-main">
            የእርስዎ ግላዊነት እና የግል መረጃ ጥበቃ ለእኛ በጣም አስፈላጊ ነው
          </p>
          <p className="page-description-sub">
            Your privacy and personal data protection is very important to us
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="content-container">
        <div className="content-header">
          <div className="content-icon">📋</div>
          <h2 className="content-title">የጥበቃ መመሪያ ዝርዝር</h2>
        </div>

        <div className="card-grid">
          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">1</span>
                የመረጃ ስብሰባ
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-blue-50 border-l-4 border-blue-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>የምንሰበስባቸው መረጃዎች:</strong><br/>
                    • የመሳሪያ መረጃ (IP አድራሻ፣ የአሳሽ አይነት)<br/>
                    • የአጠቃቀም ስታቲስቲክስ (የተጎበኙ ገጾች፣ ጊዜ)<br/>
                    • የፍላጎት ምርጫዎች (ቋንቋ፣ ገጽ ቅንብሮች)<br/>
                    • የግብረመልስ መረጃዎች (አስተያየቶች፣ ጥያቄዎች)
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">2</span>
                የመረጃ አጠቃቀም
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-green-50 border-l-4 border-green-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>መረጃዎቹን የምንጠቀምባቸው ዓላማዎች:</strong><br/>
                    • የአገልግሎት ጥራት ማሻሻል<br/>
                    • የተጠቃሚ ተሞክሮ ማሻሻል<br/>
                    • ቴክኒካል ድጋፍ መስጠት<br/>
                    • የአገልግሎት ስታቲስቲክስ ማዘጋጀት<br/>
                    • የደህንነት እርምጃዎች መውሰድ
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">3</span>
                የመረጃ ጥበቃ
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-purple-50 border-l-4 border-purple-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>የምንወስዳቸው የጥበቃ እርምጃዎች:</strong><br/>
                    • የመረጃ ምስጠራ (SSL/TLS)<br/>
                    • የመዳረሻ ቁጥጥር<br/>
                    • መደበኛ የደህንነት ግምገማ<br/>
                    • የመረጃ መጠባበቂያ እና ማገገሚያ<br/>
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">4</span>
                የመረጃ መጋራት
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-orange-50 border-l-4 border-orange-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>የግል መረጃ መጋራት:</strong><br/>
                    • የእርስዎን ግል መረጃ ለሶስተኛ ወገን አንሸጥም<br/>
                    • ያለእርስዎ ፈቃድ አናጋራም<br/>
                    • በህግ የሚጠበቅ ከሆነ ብቻ ናጋራለን<br/>
                    • የአገልግሎት አቅራቢዎች ጋር በተወሰነ መልኩ<br/>
                    • ሁሉም ሶስተኛ ወገኖች ተመሳሳይ ጥበቃ ይሰጣሉ
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">5</span>
                የእርስዎ መብቶች
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-red-50 border-l-4 border-red-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>እርስዎ ያሉዎት መብቶች:</strong><br/>
                    • የግል መረጃዎን ማየት<br/>
                    • መረጃዎን ማስተካከል<br/>
                    • መረጃዎን ማጥፋት<br/>
                    • የመረጃ ተንቀሳቃሽነት<br/>
                    • የስምምነት መሰረዝ<br/>
                    • ቅሬታ ማቅረብ
                  </p>
                </div>
              </div>
            </div>
          </div>

          <div className="card-item">
            <div className="card-header">
              <h3 className="card-title">
                <span className="card-number">6</span>
                ኩኪዎች እና ተመሳሳይ ቴክኖሎጂዎች
              </h3>
            </div>
            <div className="card-content">
              <div className="content-block bg-teal-50 border-l-4 border-teal-500 rounded-lg p-4">
                <div className="content-text">
                  <p>
                    <strong>ኩኪዎች አጠቃቀም:</strong><br/>
                    • የአገልግሎት ተሞክሮ ማሻሻል<br/>
                    • የተጠቃሚ ምርጫዎች ማስታወስ<br/>
                    • የአጠቃቀም ስታቲስቲክስ መሰብሰብ<br/>
                    • የደህንነት እርምጃዎች<br/>
                    • ኩኪዎችን በአሳሽዎ ማቀናበር ይችላሉ
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Section */}
      <div className="content-container">
        <div className="content-header">
          <div className="content-icon">📞</div>
          <h2 className="content-title">ለጥያቄዎች ያግኙን</h2>
        </div>
        
        <div className="instructions-grid">
          <div className="instruction-card">
            <div className="instruction-header">
              <span className="instruction-icon">📧</span>
              <h3 className="instruction-title">ኢሜይል</h3>
            </div>
            <p className="instruction-description">
              hailemariameyayu2012@gmail.com
            </p>
          </div>

          <div className="instruction-card">
            <div className="instruction-header">
              <span className="instruction-icon">📱</span>
              <h3 className="instruction-title">ስልክ</h3>
            </div>
            <p className="instruction-description">
              +251-938169557
            </p>
          </div>

          <div className="instruction-card">
            <div className="instruction-header">
              <span className="instruction-icon">📍</span>
              <h3 className="instruction-title">አድራሻ</h3>
            </div>
            <p className="instruction-description">
              አዲስ አበባ, ኢትዮጵያ
            </p>
          </div>

          <div className="instruction-card">
            <div className="instruction-header">
              <span className="instruction-icon">⏰</span>
              <h3 className="instruction-title">የመልስ ጊዜ</h3>
            </div>
            <p className="instruction-description">
              በ24-48 ሰዓት ውስጥ
            </p>
          </div>
        </div>
      </div>

      {/* Last Updated */}
      <div className="content-container">
        <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 text-center">
          <p className="text-sm text-gray-600">
            <strong>የመጨረሻ ማሻሻያ:</strong> ታህሳስ 2017 ዓ.ም (December 2025)<br/>
            <strong>Last Updated:</strong> December 29, 2025
          </p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;